import { render, staticRenderFns } from "./Captcha.vue?vue&type=template&id=f4ccde14&"
import script from "./Captcha.vue?vue&type=script&lang=js&"
export * from "./Captcha.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports